export default __webpack_public_path__ + "static/media/chat_wizard.0d0afc94.png";